import React from 'react';

import {Link} from '@udemy/react-core-components';
import {useUDData} from '@udemy/ud-data';

export const BROWSE_OBJECT_TYPES = {
    CATEGORY: 'category',
    SUBCATEGORY: 'subcategory',
    COURSE_LABEL: 'course_label',
    ORG_CUSTOM_CATEGORY: 'org_custom_category',
    UFB_CUSTOM_COLLECTION: 'ufb_custom_collection',
    FEATURED_TOPICS: 'featured_topics',
} as const;

interface BrowseLinkProps {
    browseObject: {
        id: number;
        title: string;
        type: (typeof BROWSE_OBJECT_TYPES)[keyof typeof BROWSE_OBJECT_TYPES];
        absolute_url?: string;
        url?: string;
    };
    className?: string;
    children: React.ReactNode;
}

export const BrowseLink = (props: BrowseLinkProps) => {
    const {Config} = useUDData();
    const {browseObject, ...passThroughProps} = props;

    const {absolute_url: absoluteUrl, id, title, type, url} = browseObject;
    const locationState = {absolute_url: absoluteUrl || url, id, title, type};
    const canonicalTo = {
        pathname: locationState.absolute_url,
        state: {
            ...locationState,
        },
    };

    if (Config.brand.has_organization) {
        canonicalTo.pathname = `/organization/home${canonicalTo.pathname}`;
    }

    return <Link {...passThroughProps} to={canonicalTo} disableRouter={true} />;
};
